import { LogoLoader } from '@kg-internal/pv3-uikit';
import cx from 'classnames';
import { ReactNode } from 'react';
import styles from './ReportCard.module.scss';

type ReportCardProps = {
  title: string;
  status: string;
  description?: string;
  icon?: ReactNode;
  classname?: string;
  percentage?: string;
  iconModifier?: string;
  statusModifier?: string;
  loading: boolean;
};

const ReportCard = ({
  title,
  status,
  description,
  icon,
  classname,
  percentage,
  iconModifier,
  statusModifier,
  loading,
}: ReportCardProps) => {
  const block = 'report-card';
  const percentageModifier = percentage && parseInt(percentage, 10) < 0 ? 'red' : 'green';
  const showPercentage = percentage && percentage !== 'N/A';

  const getPercentageIcon = () =>
    percentageModifier === 'green' ? (
      <i className='fa fa-chevron-circle-up' />
    ) : (
      <i className='fa fa-chevron-circle-down' />
    );

  return (
    <div className={cx(classname, styles[`${block}__container`])}>
      {loading ? (
        <LogoLoader inline />
      ) : (
        <>
          <div>
            <p className={styles[`${block}__title`]}>{title}</p>
            <p className={cx(styles[`${block}__status`], styles[`${block}__status--${statusModifier}`])}>{status}</p>
            {description && (
              <div className={styles[`${block}__description`]}>
                {showPercentage && (
                  <div className={styles[`${block}__description--${percentageModifier}`]}>
                    {getPercentageIcon()}
                    {percentage}%
                  </div>
                )}
                {description}
              </div>
            )}
          </div>
          {icon && (
            <div className={cx(styles[`${block}__icon`], styles[`${block}__icon--${iconModifier}`])}>{icon}</div>
          )}
        </>
      )}
    </div>
  );
};

export default ReportCard;
